import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["list", "item"];

  connect() {
    this.sortable = new Sortable(this.listTarget, {
      draggable: "[data-image-gallery-target='item']",
      filter: "button",
      preventOnFilter: false,
      animation: 150,
      onSort: () => this.renumber(),
    });
  }

  disconnect() {
    this.sortable?.destroy();
    this.sortable = undefined;
  }

  remove(event) {
    const item = event.currentTarget.closest(
      "[data-image-gallery-target='item']",
    );
    item.querySelector("[data-role='destroy']").value = "1";
    item.querySelector("[data-role='thumb']").hidden = true;
    item.querySelector("[data-role='removed']").hidden = false;
  }

  restore(event) {
    const item = event.currentTarget.closest(
      "[data-image-gallery-target='item']",
    );
    item.querySelector("[data-role='destroy']").value = "";
    item.querySelector("[data-role='thumb']").hidden = false;
    item.querySelector("[data-role='removed']").hidden = true;
  }

  renumber() {
    this.itemTargets.forEach((item, index) => {
      const position = item.querySelector("[data-role='position']");
      if (position) position.value = index;
    });
  }
}
